import { useState } from 'react'
import { useGame } from '../state/store'
import { GLOBAL } from '../config/global'
import { Decimal, fmt } from '../engine/decimal'

export function PublishButton() {
  const ink = useGame((s) => s.ink)
  const edition = useGame((s) => s.edition)
  const publishEdition = useGame((s) => s.publishEdition)
  const [showConfirm, setShowConfirm] = useState(false)

  const threshold = GLOBAL.prestigeInkEdition1 *
    Math.pow(GLOBAL.prestigeGrowthPerEdition, edition)
  const canPublish = ink.gte(threshold)
  const typeEarned = Math.floor(Math.sqrt(ink.toNumber()) / 25.2)

  if (!canPublish && !showConfirm) return null

  if (showConfirm) {
    return (
      <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/70">
        <div className="mx-4 w-full max-w-sm rounded-lg border border-ink-border bg-ink-panel p-6 text-center">
          <div className="mb-2 text-lg font-bold text-ink-teal">
            Publish New Edition
          </div>
          <div className="mb-4 text-sm text-ink-text">
            Reset letters, ink, and mastery. Gain{' '}
            <span className="font-bold text-ink-teal">{typeEarned} Type</span>{' '}
            permanently.
          </div>
          <div className="mb-4 text-xs text-ink-muted">
            Edition {edition} → {edition + 1}
          </div>
          <div className="flex gap-3">
            <button
              onClick={() => setShowConfirm(false)}
              className="flex-1 rounded border border-ink-border px-3 py-2 text-xs text-ink-muted hover:bg-ink-bg"
            >
              Cancel
            </button>
            <button
              onClick={() => {
                publishEdition()
                setShowConfirm(false)
              }}
              className="flex-1 rounded border border-ink-teal px-3 py-2 text-xs font-bold text-ink-teal hover:shadow-glow"
            >
              Publish ({typeEarned} Type)
            </button>
          </div>
        </div>
      </div>
    )
  }

  return (
    <button
      onClick={() => setShowConfirm(true)}
      className="w-full rounded-lg border border-ink-teal bg-ink-panel p-3 text-center transition hover:shadow-glow"
    >
      <div className="text-xs font-bold uppercase tracking-widest text-ink-teal">
        Publish Edition {edition + 1}
      </div>
      <div className="mt-1 text-[10px] text-ink-muted">
        Requires {fmt(new Decimal(threshold))} Ink · Earn {typeEarned} Type
      </div>
    </button>
  )
}
